module.exports = __webpack_public_path__ + "img/dec_15_1.01fdc07d.jpg";